import {ChacrasActions, ChacrasActionTypes} from './chacras.actions';
import {chacrasAdapter, ChacrasState, initialState} from './chacras.state';

export function chacrasReducer(state = initialState, action: ChacrasActions): ChacrasState {
  switch (action.type) {
    // load
    case ChacrasActionTypes.CHACRAS_LOAD_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null
      };
    }
    case ChacrasActionTypes.CHACRAS_LOAD_SUCCESS: {
      return chacrasAdapter.setAll(action.payload.items, {
        ...state,
        isLoading: false,
        error: null
      });
    }
    case ChacrasActionTypes.CHACRAS_LOAD_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    case ChacrasActionTypes.CHACRAS_PADRONUPDATE_SUCCESS: {
      return chacrasAdapter.updateMany(action.payload.items, {
        ...state
      });
    }
    // get padrones
    case ChacrasActionTypes.CHACRAS_GETPADRONES_REQUEST: {
      return {
        ...state,
        isLoading: false, // dont want to stop app
        error: null
      };
    }
    case ChacrasActionTypes.CHACRAS_GETPADRONES_SUCCESS: {
      return chacrasAdapter.updateOne(action.payload.item, {
        ...state,
        isLoading: false,
        error: null
      });
    }
    case ChacrasActionTypes.CHACRAS_GETPADRONES_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    // get suelos
    case ChacrasActionTypes.CHACRAS_GETSUELOS_REQUEST: {
      return {
        ...state,
        isLoading: action.payload.loading,
        getSuelosLoading: true,
        error: null
      };
    }
    case ChacrasActionTypes.CHACRAS_GETSUELOS_SUCCESS: {
      return chacrasAdapter.updateOne(action.payload.item, {
        ...state,
        isLoading: false,
        getSuelosLoading: false,
        error: null
      });
    }
    case ChacrasActionTypes.CHACRAS_GETSUELOS_FAILURE: {
      return chacrasAdapter.updateOne(action.payload.item, {
        ...state,
        isLoading: false,
        getSuelosLoading: false,
        error: null
      });
    }
    // get LS
    case ChacrasActionTypes.CHACRAS_GETLS_REQUEST: {
      return {
        ...state,
        isLoading: action.payload.loading,
        error: null
      };
    }
    case ChacrasActionTypes.CHACRAS_GETLS_SUCCESS: {
      return chacrasAdapter.updateOne(action.payload.item, {
        ...state,
        isLoading: false,
        error: null
      });
    }
    case ChacrasActionTypes.CHACRAS_GETLS_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    // get Tipo Laboreo
    case ChacrasActionTypes.CHACRAS_GET_TIPO_LABOREO_REQUEST: {
      return {
        ...state,
        isLoading: false,
        error: null
      };
    }
    case ChacrasActionTypes.CHACRAS_GET_TIPO_LABOREO_SUCCESS: {
      return chacrasAdapter.updateOne(action.payload.item, {
        ...state,
        isLoading: false,
        error: null
      });
    }
    case ChacrasActionTypes.CHACRAS_GET_TIPO_LABOREO_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    // get Factor p
    case ChacrasActionTypes.CHACRAS_GET_FACTOR_P_REQUEST: {
      return {
        ...state,
        isLoading: false,
        error: null
      };
    }
    case ChacrasActionTypes.CHACRAS_GET_FACTOR_P_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: null
      };
    }
    case ChacrasActionTypes.CHACRAS_GET_FACTOR_P_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    case ChacrasActionTypes.CHACRAS_CHANGE_PENDIENTE: {
      return {
        ...state,
        changePendiente: action.payload.item
      };
    }
    // default
    default: {
      return state;
    }
  }
}
